module.exports = __webpack_public_path__ + "master.png";